$(document).ready(function() {
  var sortObj = {
    selling: { up: "manual", down: "best-selling" },
    price: { up: "price-ascending", down: "price-descending" },
    created: { up: "created-descending", down: "created-ascending" },
    discount: { up: "discount-low", down: "discount-high" }
  };

  var handleViewItemClick = function() {
    $(this).closest('.collection-product-grid').find('.collection-product-grid-item').show();
    $(this).hide();
    $(this).closest('.collection-product-grid').addClass("view-all");
  };

  var handleSortItemClick = function() {
    var $this = $(this);
    var sortValue = $this.data("value");
    var currentOrder = $this.data("order");
    var newOrder = "";
    newOrder = $this.hasClass("active") 
      ? (currentOrder === "up" ? "down" : "up") 
      : currentOrder;

    // 获取当前网格的容器
    var $currentGrid = $this.closest('.collection-product-grid');
    var $listContainer = $currentGrid.find('.collection-product-grid-list');

    // 如果是折扣率排序，则执行客户端排序（只针对当前网格）
    if (sortValue === 'discount') {
      $currentGrid.find(".sort-item").removeClass("active");
      $this.addClass("active").data("order", newOrder).attr("data-order", newOrder);
      
      performClientSideDiscountSorting(newOrder, $listContainer);
      return;
    }

    var sortBy = sortObj[sortValue][newOrder];

    $currentGrid.find(".sort-item").removeClass("active");
    $this.addClass("active").data("order", newOrder).attr("data-order", newOrder);

    var params = { sort_by: sortBy };
    var sectionId = $currentGrid.attr("id");
    $currentGrid.attr("data-loading", "true");

    const url = `${window.location.pathname}?section_id=${sectionId}&${$.param(params)}`;
    const newUrl = `${window.location.pathname}?${$.param(params)}`;
    history.pushState('', '', newUrl);

    fetch(url, {
      credentials: 'same-origin',
      method: 'GET'
    })
    .then(response => response.text())
    .then(content => {
      var tempElement = document.createElement('div');
      tempElement.innerHTML = content;
      var newCollectionProductGrid = tempElement.querySelector('.collection-product-grid');

      if (newCollectionProductGrid) {
        $('#' + sectionId).html(newCollectionProductGrid.innerHTML);
        updateSortAttributes(sortValue, newOrder);
        rebindEventHandlers();
      }
    })
    .catch(error => console.error('Error:', error))
    .finally(() => $currentGrid.attr("data-loading", "false"));
  };

  var updateSortAttributes = function(sortValue, newOrder) {
    $(".sort-item").each(function() {
      var $item = $(this);
      if ($item.data("value") === sortValue) {
        $item.data("order", newOrder).attr("data-order", newOrder);
      }
    });
  };

  // 客户端折扣率排序函数（接受容器参数）
  var performClientSideDiscountSorting = function(order, container) {
    var productItems = container.find('.collection-product-grid-item');
    
    var productsWithDiscount = [];
    
    productItems.each(function(index, item) {
      var $item = $(item);
      var discountElement = $item.find('.product-discount');
      var discountRate = 0;
      
      if (discountElement.length > 0) {
        var discountText = discountElement.text().trim();
        var match = discountText.match(/\d+/);
        if (match) {
          discountRate = parseInt(match[0]);
        }
      }
      
      productsWithDiscount.push({
        element: $item,
        discountRate: discountRate,
        originalIndex: index
      });
    });
    
    productsWithDiscount.sort(function(a, b) {
      if (order === 'down') {
        var diff = b.discountRate - a.discountRate;
        if (diff !== 0) return diff;
        return a.originalIndex - b.originalIndex;
      } else {
        var diff = a.discountRate - b.discountRate;
        if (diff !== 0) return diff;
        return a.originalIndex - b.originalIndex;
      }
    });
    
    container.empty();
    productsWithDiscount.forEach(function(productData) {
      container.append(productData.element);
    });
  };

  var rebindEventHandlers = function() {
    $(".sort-item").off('click').on('click', handleSortItemClick);
    $('#view-all-btn').off('click').on('click', handleViewItemClick);
  };

  // 页面加载完成后，如果有默认折扣排序，只对包含活跃排序项的网格执行
  $(window).on('load', function() {
  setTimeout(function() {
    // 遍历页面上所有的产品网格
    $('.collection-product-grid').each(function() {
      var $grid = $(this);
      var $activeSortItem = $grid.find('.sort-item.active');
      
      if ($activeSortItem.length) {
        var sortValue = $activeSortItem.data('value');
        if (sortValue === 'discount') {
          var order = $activeSortItem.data('order');
          var $container = $grid.find('.collection-product-grid-list');
          // 调用折扣排序函数，传入当前网格的容器
          performClientSideDiscountSorting(order, $container);
        }
        // 如果未来需要处理其他排序类型的自动触发，可在此扩展
      }
    });
  }, 100);
});

  rebindEventHandlers();
});

// Use Code（保持不变）
$(document).ready(function() {
  $(".product-coupon-code").click(function() {
      var textToCopy = $(this).find("span").text();
      console.log(textToCopy);

      var $tempInput = $('<input>', {
          type: 'text',
          value: textToCopy,
          css: {
              position: 'absolute',
              left: '-9999px'
          }
      }).appendTo('body');
      $tempInput[0].select();
      
      var copied = document.execCommand('copy');
      $tempInput.remove();

      if (copied) {
          var $successMessage = $('<div>', {
              text: 'Copied!',
              css: {
                  position: 'fixed',
                  bottom: '20px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  padding: '6px 12px',
                  backgroundColor: '#404A58',
                  color: 'white',
                  textAlign: 'center',
                  borderRadius: '5px',
                  zIndex: '999'
              }
          }).appendTo('body');
          setTimeout(function() {
              $successMessage.fadeOut(500, function() { $(this).remove(); });
          }, 2000);
      }
  });
});

// Product list more btn（保持不变）
$(document).ready(function() {
  $(".product-list__more-btn").click(function() {
    $(this).hide();
    var $closestCollection = $(this).closest('.collection-product-list');
    var handleValue = $closestCollection.data('handle');
    $(`.collection-product-list[data-handle="${handleValue}"] .product-list__item`).show();
  });
});